export default __webpack_public_path__ + "static/media/ministerio-04.e3185e1d.svg";